export const MAX_REWARD = 5;
export const PENALTY = 1;
export const MAX_LEVEL = 5;
export const MAX_SCORE = 5;
export const MAX_TOTAL_SCORE = MAX_SCORE * (MAX_LEVEL + 1);

export const APP_START_TAB_ID = 0;

export const COUNT_ANSWERS = 6;

export const VOLUME_LEVEL_DEFAULT = 0.4;

export const HIDDEN_BIRD_NAME = '*******';
